export class SocialMediaService {
  constructor(axios, cmsUrl, apiUrl) {
    this.axios = axios;
    this.cmsUrl = cmsUrl;
    this.apiUrl = apiUrl;
  }

  async postTestimonial(
    customerNumber,
    companySqldbid,
    sessionID,
    testimonial
  ) {
    return await this.axios.post(
      `${this.apiUrl}SocialMedia/Testimonials/Customer/${customerNumber}/Company/${companySqldbid}/Testimonial`,
      testimonial,
      {
        headers: { "X-SessionId": sessionID }
      }
    );
  }
}
